const t=({cartUrl:t,next:a,push:e,type:l="default"})=>{e(`${t[l]||t.default}${a?`/?next=${a}&origin=magazineluiza`:""}`)};export{t as default};
